import {commonHeaders} from './fetch.util';

export const COUPON_REGISTRATION = 'COUPON_REGISTRATION';

export function couponRegistration(pcbId, code) {
  return {
    type: COUPON_REGISTRATION,
    pcbId,
    code,
  };
}

export function postCouponRegistration(pcbId, code, history) {
  return dispatch => {
    dispatch(couponRegistration(pcbId, code));

    fetch(`${API_URL}/coupons/by-code/${code}/?pcbId=${pcbId}`, {
      method: 'POST',
      headers: commonHeaders(),
    }).then(response => {
      if (response.status === 201) {
        alert('쿠폰 코드가 등록 되었습니다.');
        history.push('/my-pc-bang/usage-status/payment-and-billing');
      } else if (response.status === 409) {
        alert('이미 등록 된 쿠폰 코드 입니다.');
      } else {
        alert('쿠폰 코드 등록에 실패했습니다.');
      }
    });
  };
}
